module.exports = __webpack_public_path__ + "img/05_kudo_14.3977ad83.jpg";